import type {
  FormStyleMap,
  FormStyleState,
  FormStyleStateKey,
} from '@/app/components/forms/styles';
import { cn } from '@/app/utils/cn';

/**
 * Utility function for resolving a final className string from a style config object
 * and current UI state flags (e.g., error, disabled, checked).
 */
export function getCustomFormStyle<K extends FormStyleStateKey>(
  style?: FormStyleMap<K>,
  state?: FormStyleState<K>
): string {
  if (!style) return '';

  return cn(
    style.base,
    ...Object.entries(state ?? {}).flatMap(([key, active]) =>
      active && key in style ? [style[key as K]] : []
    )
  );
}
